import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../images/Logo.png';
import GrantImage from '../images/Grant.JPG';
import IntelligenceTypeImage from '../images/IntelligenceTypeImage.jpg';
import MyTypes from '../images/MyTypes.PNG';
import NotableFiguresImage from '../images/NotableFiguresImage.jpg';
import IntelTestImage from '../images/IntelTestImage.jpg';
import MapImage from '../images/MapImage.jpg';
import DestinationImage from '../images/DestinationImage.jpg';
import FilterImage from '../images/FilterImage.jpg';
import ChartImage from '../images/Chart.jpg';
import '../styles/template.css';

const AboutPage = () => {
  return (
    <div className="container">
      <header>
        <div className="logo-container">
          <img src={Logo} alt="Logo" className="logo" />
        </div>
        <h1>About Us</h1>
        <nav>
          <ul>
            <li><Link to='/'>Home</Link></li>
            <li><Link to='/about'>About</Link></li>
            <li><Link to='/partners'>Partners</Link></li>
            <li><Link to='/destinations'>Get Featured</Link></li>
            <li><Link to='/connect'>Meetups</Link></li>
            <li><Link to='/contact'>Contact Us</Link></li>
          </ul>
        </nav>
      </header>
      <main>
        <h2>Unlock Your Full Potential</h2>
        <p>
          Know Yourself helps you find your natural talents and connect with activities that make the most of your strengths. This changes how you learn, work, and feel happy about what you do.
        </p>
        <img src={ChartImage} alt="Intelligence Chart" className="chart-image" />
        <p>
          Take our quiz to learn about your intelligence type and see what makes you unique.
        </p>
        <div className="image-row">
          <img src={IntelTestImage} alt="Intelligence Assessment" className="image-row-item" />
          <img src={MyTypes} alt="My Intelligence Types" className="image-row-item" />
        </div>
        <p>Get inspired by famous people who think like you do.</p>
        <div className="image-row">
          <img src={IntelligenceTypeImage} alt="Intelligence Type Description" className="image-row-item" />
          <img src={NotableFiguresImage} alt="Notable Figures" className="image-row-item" />
        </div>
        <p>
          Turn what you learn into action with activities that match how you think. Find things to do that feel natural and easy because they fit how your mind works best.
        </p>
        <div className="image-row">
          <img src={MapImage} alt="Map" className="image-row-item" />
          <img src={DestinationImage} alt="Destination" className="image-row-item" />
          <img src={FilterImage} alt="Filter" className="image-row-item" />
        </div>
        <h2>________________________</h2>
        <div className="team-member">
          <img src={GrantImage} alt="Grant Reynolds - Know Yourself CEO" className="profile-image" />
          <h3>Founder / CEO - Grant Reynolds</h3>
          <p>
            Success comes when we use our natural talents instead of fighting against them.
          </p>
          <p>
            I created Know Yourself to help people discover their strengths and apply them in the real world. This isn't just about learning who you are - it's about taking action and getting involved in your community.
          </p>
        </div>
      </main>
      <footer>
        <p>&copy; 2026 Know Yourself LLC | All rights reserved.</p>
      </footer>
    </div>
  );
};

export default AboutPage;
